import Image from 'next/image';
import OpenBox from '@images/shopping/open-box.svg';
import Button from '@components/Forms/Button';

import styles from './styles.module.css';
import {useTranslation} from 'next-i18next';

export default function NoOrder() {
  const {t} = useTranslation('customer-orders');

  return (
    <div className={`${styles.noOrderContainer}`}>
      <div className={`${styles.noOrder}`}>
        <div className={`${styles.image}`}>
          <Image
            alt={t<string>('titles.no_orders')}
            src={OpenBox}
            height={100}
            width={150}
          />
        </div>
        <h2>{t<string>('titles.no_orders')}</h2>
        <h5>{t<string>('helpers.no_orders')}.</h5>
        <Button>{t<string>('buttons.go_shopping')}</Button>
      </div>
    </div>
  );
}
